//
//
//
//
//
//
//
//


export default {
  name: "layoutHome",
  data: () => ({
    loading: true
  }),
  created() {
    this.$nextTick(function() {
      this.loading = false
    })
  }
}
